import React from 'react'

const Manual_configuracion_pedidos_programados = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configuración de pedidos programados
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo activar y configurar pedidos programados dentro del portal de Clau.io para mejorar la gestión de entregas.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configuracion_de_pedidos_programados___ApFstaQR0ahQLd2OWcoPQ?as=scrollable"
          className="scribe-iframe-general-101"
          width="100%"
          height="4600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_configuracion_pedidos_programados
